<template>
  <g-field :label="skipLabel ? null : $t('label.jenis_pemasukan')" :type="displayType" :message="displayMessage">
    <g-select :value="value" @input="onInput" :is-fullwidth="isFullwidth" :disabled="disabled"
              :placeholder="options.length === 0 ? $t('text.no_content_loaded') : $t('label.choose') + ' ' + $t('label.jenis_pemasukan')">
      <option v-for="item in options" :key="item.id" :value="item.id">
        {{ getLabel(item) }}
      </option>
    </g-select>
  </g-field>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'annotation';
import Store from '../../../util/Store';
import { useTUKStore } from '../../../stores/tuk.store';
import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component({
  components: {
    'g-field': GField,
    'g-select': GSelect
  }
})
export default class JenisPemasukanSelect extends Vue {

  @Prop({ default: null })
  public value: any;

  @Prop({ default: false, type: Boolean })
  public skipLabel: boolean;

  @Prop({ default: true, type: Boolean })
  public isFullwidth: boolean;

  @Prop({ type: String, default: null })
  public type: any;

  @Prop({ type: String, default: null })
  public message: any;

  @Prop({ type: Boolean, default: false })
  public disabled: any;

  @Prop({ type: String, default: null })
  public bendaharaType: string|null;

  @Prop({ type: Array, default: null })
  public optionsProp: any[] | null;

  public tukStore = useTUKStore();

    public get options() {
      // If custom options are provided via prop, use them directly
      if (this.optionsProp) {
        return this.optionsProp;
      }

      const allOptions = Store.getVmProperty('jenisPemasukan.data', []);
      
      let allowedIds: number[] = [];

      // If bendaharaType prop is provided, filter based on that specific type's config
      if (this.bendaharaType) {
        // If it's the same type as the logged in user, use userConfig
        if (this.tukStore.userConfig?.bendahara_type === this.bendaharaType) {
          allowedIds = (this.tukStore.userConfig?.allowed_jenis_pemasukan || []).map(item => item.id);
        } else {
          const config = this.tukStore.bendaharaConfigs.find(c => c.bendahara_type === this.bendaharaType);
          if (config) {
            allowedIds = config.allowed_jenis_pemasukan.map(item => item.id);
          } else {
            // If type is selected but config not found, only allow current value to avoid showing everything
            return allOptions.filter((opt: any) => opt.id === this.value);
          }
        }
      } else {
        // Fallback to current user's config
        allowedIds = (this.tukStore.userConfig?.allowed_jenis_pemasukan || []).map(item => item.id);
      }

      if (allowedIds.length > 0) {
        return allOptions.filter((opt: any) => allowedIds.includes(opt.id) || opt.id === this.value);
      }

      return allOptions;
    }

  public get displayMessage() {
    const { message } = this;
    return typeof message === 'object' && message !== null ? message.message : message;
  }

  public get displayType() {
    const { message, type } = this;
    return typeof message === 'object' && message !== null ? message.type : type;
  }

  public async created() {
    await Store.dispatchJenisPemasukan();
  }

  public onInput(val: any) {
    this.$emit('input', val);
    this.$emit('change', val);
    const selected = this.options.find((opt: any) => opt.id === val);
    if (selected) {
      this.$emit('selected-item', selected);
    }
  }

  public getLabel(item: any): string {
    const label = item.nama || item.name || item.id || 'DATA KOSONG';
    return String(label).toUpperCase();
  }
}
</script>
